import { useState } from "react"
import { NavLink } from "react-router-dom"
import logo from "../../images/common/vgc-text.png"
import styled from "styled-components"
import ModalBootstrap from "./ModalBootstrap"
import Rules from "./Rules"
import { useUser } from "../../context/useUser"
import { useLeague } from "../../context/useLeague";
import SignUpForm from "../auth/SignUpForm.js"
import LoginForm from "../auth/LoginForm"

const Navbar = () => {

  const { user, logout } = useUser()
  // const { league } = useLeague()

  // login/logout

  const handleClickLogin = () => {
    if (user) {
      logout()
    } else {
      setShowLogin(true)
      toggleModal()
    }
  }

  // open mobile dropdowns

  const [dropdownOpen, setDropdownOpen] = useState(false)

  const handleToggle = () => {
    setDropdownOpen(!dropdownOpen)
  }

  // login modal

  const [openLogin, setOpenLogin] = useState(false)
  const toggleModal = () => setOpenLogin(!openLogin)
  const [showLogin, setShowLogin] = useState(true)
  const toggleLogin = () => setShowLogin(!showLogin)

  // rules modal

  const [modalOpen, setModalOpen] = useState(false)

  const openModal = () => {
    setModalOpen(true)
  }
  const closeModal = () => {
    setModalOpen(false)
  }

  return (
    <div
      className="container-fluid sticky-nav"
      style={{ padding: 0, margin: 0 }}
    >
      <Nav
        className="navbar navbar-expand-lg navbar-dark bg-dark"
        id="custom-navbar"
      >
        <NavLink className="navbar-brand ms-2" to="/">
          {/* logo */}
          <img
              alt={"VGC logo"}
            src={logo}
            style={{ marginBottom: "0.1rem", width: "100px" }}
              className="my-2"
          ></img>
        </NavLink>
        {/* mobile tabs */}
        <MobileLink className="me-5">
          {/* rules mobile */}
          <Link className="me-sm-3 me-4" onClick={openModal}>
            Rules
          </Link>
        </MobileLink>
        {/* if not logged in show login in the mobile nav bar */}
        {!user ? (
          <MobileLink className="me-3">
            <Link onClick={handleClickLogin} className="">
              {user ? "Logout" : "Login"}
            </Link>
          </MobileLink>
        ) : null}
        {/* hamburger */}
        { user ?
            <button
                className="navbar-toggler me-2 float-end"
                type="button"
                data-toggle="collapse"
                data-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
                onClick={handleToggle}
            >
              <span className="navbar-toggler-icon"></span>
            </button>
        : null }
        <div
          className="collapse navbar-collapse mt-1"
          style={{ display: dropdownOpen ? "block" : "none" }}
        >

          {/* Authenticated nav links */}
          { user ?
              <ul className="navbar-nav" style={{ width: "100%" }}>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/profile">
                    Profile
                  </NavLink>
              </li>
              {
                user.leagues.length ?
                <li className="nav-item">
                  <NavLink className="nav-link" to="/teamhub">
                    Team Hub
                  </NavLink>
                </li>
                : null
              }
                <li className="nav-item">
                  <NavLink className="nav-link" to="/leaderboard">
                    Leaderboard
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/tables">
                    League Tables
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/transfers">
                    Transfers
                  </NavLink>
                </li>
                {/* <li className="nav-item active">
              <NavLink className="nav-link" to="/news">
                News
              </NavLink>
            </li> */}
                <li className="nav-item">
                  <NavLink className="nav-link" to="/store">
                    Store
                  </NavLink>
                </li>
                {/* if logged in show logout in hamburger menu  */}
                <li className="nav-item d-block d-lg-none">
                  <Link onClick={handleClickLogin} className="nav-link">
                    {user ? "Logout" : "Login"}
                  </Link>
              </li>
              {/* Admin Area */}
              {user.isAdmin || user.isStaff ?
              <li className="nav-item">
                <NavLink className="nav-link" to="/admin">
                  Admin
                </NavLink>
              </li>
             : null}
              </ul>
          : null }

          <LargeScreenLinks className="nav-item me-5">
            {/* rules large */}
            <Link className="nav-link" onClick={openModal}>
              Rules
            </Link>
            <Link onClick={handleClickLogin} className="nav-link">
              {user ? "Logout" : "Login"}
            </Link>
          </LargeScreenLinks>
          {/* if logged in show logout in hamburger menu  */}
          {/*{user ? (*/}
          {/*    <li className="nav-item d-block d-lg-none">*/}
          {/*      <Link onClick={handleClickLogin} className="nav-link">*/}
          {/*        {user ? "Logout" : "Login"}*/}
          {/*      </Link>*/}
          {/*    </li>*/}
          {/*) : null}*/}
        </div>
      </Nav>

      {/* rules modal */}

      {modalOpen ? (
        <ModalBootstrap
          title={`VGC Rules and Regulations`}
          submitText={"Offer Contract"}
          // display={true}
          closeModal={closeModal}
          submitButton={false}
          component={<Rules />}
        />
      ) : null}

      {/* login modal */}

      {openLogin ? (
        showLogin ? (
          <LoginForm
            toggleModal={toggleModal}
            modalOpen={openLogin}
            toggleLogin={toggleLogin}
          />
        ) : (
          <SignUpForm
            toggleModal={toggleModal}
            modalOpen={openLogin}
            toggleLogin={toggleLogin}
          />
        )
      ) : null}
    </div>
  )
}

export default Navbar

const Nav = styled.nav`
//min-height: 3rem;
`

const LargeScreenLinks = styled.li`
  position: absolute;
  right: 0;
  //gap: 1rem;
  display: flex;
  @media (max-width: 991px) {
    display: none;
  }
`
const MobileLink = styled.li`
  text-decoration: none;
  color: white;
  gap: 1rem;
  display: flex;
  @media (min-width: 991px) {
    display: none;
  }
`
const Link = styled.div`
  color: grey;
  cursor: pointer;
  &:hover {
    color: #d3d3d3;
  }
`
